var _defs, _path, _path2, _tspan, _tspan2, _tspan3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeaderTagRedeem = function SvgHeaderTagRedeem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 453.99 358.99"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-6{isolation:isolate}.cls-2{fill:#f2f2f2}.cls-6{font-size:42px;fill:#222;font-family:SofiaPro-Bold,Sofia Pro;font-weight:700}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.89.1c-.5 19.6 2.2 53.3-4.4 71.8-4.2 14.2-12.2 31.8-27.1 50.8-19.9 25.4-62.9 43.6-94.4 51.7a30.41 30.41 0 0 0-4.1-3.9L271 138.7a13.41 13.41 0 0 0-12.4-2.1l-231.9 81c-4.9 1.8-7.1 8-5 13.8l43.6 119.7c2.1 5.9 7.8 9.2 12.7 7.4l235-99.8a13.19 13.19 0 0 0 8.1-9.5l13.9-53.3.3-1.2a24.25 24.25 0 0 1 15.4-18.5c26.9-10.1 53-26.8 70-48.6 14.5-18.6 22.9-35.8 27.6-50.6 7.9-20.8 5.1-55 5.6-77h-8Z",
    style: {
      isolation: "isolate",
      opacity: 0.3
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1349-2",
    d: "m270 134.7 44.9 31.9a24.39 24.39 0 0 1 9.2 25.4l-13.9 53.3a13.41 13.41 0 0 1-8.1 9.5l-245 99.8c-4.9 1.8-10.6-1.5-12.7-7.4L.79 227.5c-2.1-5.9.1-12.1 5-13.8l251.9-81a13 13 0 0 1 12.31 2Zm27.6 65.3a12 12 0 1 0-15.4-7.2 11.82 11.82 0 0 0 15.4 7.2c-.1.1 0 .1 0 0Z",
    className: "cls-2",
    "data-name": "Path 1349-2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_998",
    d: "M322.79 173.1a4.78 4.78 0 0 1-2.8 6.1l-20.5 7.5a4.78 4.78 0 0 1-6.1-2.8 4.78 4.78 0 0 1 2.8-6.1l20.5-7.5a4.69 4.69 0 0 1 6.1 2.8Z",
    "data-name": "Rectangle 998",
    style: {
      fill: "#e2e6e8"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_999-2",
    d: "M326 182.1a4.75 4.75 0 0 1-2.9 6.1l-20.5 7.4a4.75 4.75 0 0 1-6.1-2.9 4.75 4.75 0 0 1 2.9-6.1l20.6-7.4a4.68 4.68 0 0 1 6 2.9Z",
    className: "cls-2",
    "data-name": "Rectangle 999-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gift_cards",
    "data-name": "Gift cards"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Thank_you",
    "data-name": "Thank you"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4 198.2H262v95.2H57.4z",
    style: {
      fill: "none"
    },
    transform: "rotate(-20 159.692 245.777)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "rotate(-20 767.674 -94.186)"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      letterSpacing: "-.02em"
    }
  }, "R"), _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 25.75,
    y: 0
  }, "edeem "))), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "rotate(-20 882.198 -107.938)"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      letterSpacing: "-.01em"
    }
  }, "y"), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 21,
    y: 0
  }, "ou")), /*#__PURE__*/React.createElement("tspan", {
    x: 69.63,
    y: 0,
    style: {
      letterSpacing: "-.03em"
    }
  }, "r"), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    xmlSpace: "preserve",
    x: 85.81,
    y: 0
  }, " gift")))))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1000",
    d: "m318.89 166.1 1.5-.5a4.49 4.49 0 0 1 5.8 2.7l5.6 15.3a4.49 4.49 0 0 1-2.7 5.8l-1.5.5a4.49 4.49 0 0 1-5.8-2.7l-5.6-15.3a4.48 4.48 0 0 1 2.7-5.8Z",
    "data-name": "Rectangle 1000",
    style: {
      fill: "#cdd7dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.19.1c-.4 17.3 1.5 51.7-2.5 68.3a136 136 0 0 1-22.4 51.6c-26.3 36.8-64 49.4-79 53.1l1.9 7.8c19.7-4.9 56.8-18.7 83.6-56.2a144.14 144.14 0 0 0 25.4-64.6c1.8-11 .7-48.2 1-59.9h-8Z",
    style: {
      fill: "#e5e5e5"
    }
  })))));
};
export default SvgHeaderTagRedeem;